
import Vue from 'vue'
import { mapState } from 'vuex';
export default Vue.extend({

    props: {
        
        fromCart: {
            required: false,
            default: false,
            type: Boolean
        },
        
        isSmall: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    computed: {
        ...mapState('partner', ["partnerSettings"]),
        ...mapState("ui", ["isMobileViewDisplayed"])
    },

    methods: {
        minusBtnClicked() {
            this.$emit("decreaseQuantity");
        }
    }
})
